import { isEmpty } from 'ramda';

const REGEX = {
  CVV: /^[0-9\b]+$/,
  EMAIL:
    /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  HOLEXSHOTS: /Hole\d+Shots/i,
  PASSWORD: /^$|.{6,}$/
};

export const isValidEmail = (email: string): boolean => {
  return REGEX.EMAIL.test(email);
};

export const isValidPassword = (password: string): boolean => {
  return REGEX.PASSWORD.test(password);
};

export const isValidUserId = (userId: string): boolean => {
  return (
    !isEmpty(userId) &&
    userId.length <= 10 &&
    !Number.isNaN(Number(userId)) &&
    !Number.isNaN(parseInt(userId, 10))
  );
};
